import './GamAd.scss';
import { AdUnit } from '@moment/components/AdUnit/AdUnit.tsx';
import { IAdMapData, IGeneralSize, } from '@pages/Root/pages/HomeRoot/interfaces.ts';
import { LazyAd } from '@moment/components/LazyAd/LazyAd.tsx';
import { useMemo, useState } from 'react';
import { DEFAULT_AD_HEIGHT } from '@moment/shared-code/ad-utils.tsx';

export interface GamAdProps {
  adUnitId: string;
  adType: 'top' | 'bot';
  size: IGeneralSize;
  responsiveSize?: IAdMapData[];
  containerClassName: string;
  adBlockClassName: string;
  extraTargeting?: Record<string, string | string[]>;
}

export const GamAd = (props: GamAdProps) => {
  const [isInView, setIsInView] = useState(false);
  const adHeight = useMemo(
    () => (props.size ? props.size[1] : DEFAULT_AD_HEIGHT),
    [props.size]
  );

  return useMemo(
    () => (
      <LazyAd
        id={`gam_ad_${props.adUnitId}`}
        onInViewChange={setIsInView}
        height={adHeight}
      >
        {isInView && (
          <AdUnit
            adUnitId={props.adUnitId}
            size={props.size}
            adType={props.adType}
            responsiveSize={props.responsiveSize || []}
            containerClassName={props.containerClassName}
            adBlockClassName={props.adBlockClassName}
          />
        )}
      </LazyAd>
    ),
    [
      props.adUnitId,
      props.adType,
      props.size,
      props.responsiveSize,
      props.containerClassName,
      props.adBlockClassName,
      props.extraTargeting,
      isInView,
    ]
  );
};
